import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useUserContext } from "../../context";

const CoverPage = ({ }) => {
  const { sub } = useUserContext();

  return (
    sub?.issubexp && (
      <div className="absolute inset-0 flex flex-col bg-black bg-opacity-60 backdrop-blur-sm z-10 ">
        <div className="relative top-0 w-full h-full">
          <div
            className="absolute w-full h-full"
            style={{ backgroundColor: "grey", opacity: 0.1 }}
          />
          {/* Content */}
          <div className="relative z-10 flex items-center w-full h-full flex-col text-white p-4 md:p-8">
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 text-center">
              Subscribe to Unlock
            </h1>
            <FontAwesomeIcon
              icon={faLock}
              className="text-4xl sm:text-6xl mb-6"
            />
            <Link to="/Subscriptions">
              <button className="bg-darkMode-green text-black  px-6 py-3 rounded-full text-lg sm:text-xl transition-transform hover:scale-105 hover:bg-green-400 focus:outline-none">
                View Plans
              </button>
            </Link>
          </div>
        </div>
      </div>
    )
  );
};

export default CoverPage;
